import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { getRoles } from "@qgiv/p2p-registration";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectTeamModalOpen } from "../../../redux/slices/appSettingsSlice";
import RegistrationRole from "./RegistrationRole";

const ConnectedRegistrationRole = ({ controlId }) => {
    const { values } = useFormikContext();
    const { Category = [] } = values;

    const {
        enableIndividualRegistration,
        enableTeams,
        enableTeamCreation,
        enableTeamJoin,
    } = useSelector(selectAllP2pSettings);

    const teamModalOpen = useSelector(selectTeamModalOpen);

    const categories = useSelector(selectAllCategories);
    const category = categories.find(
        (_category) => `${_category.id}` === Category[0],
    );

    const roles = category
        ? getRoles({
              category,
              enableIndividualRegistration,
              enableTeams,
          })
        : [];

    const isHiddenByEventSettings =
        enableIndividualRegistration &&
        (enableTeams === false ||
            (enableTeamCreation === false && enableTeamJoin === false));

    const isHiddenByCategorySettings =
        category &&
        category.attachIndividual &&
        category.attachTeamCaptains === false &&
        category.attachTeamMembers === false;

    const isHidden = isHiddenByEventSettings || isHiddenByCategorySettings;

    const registrationRoleProps = {
        controlId,
        isHidden,
        roles,
        teamModalOpen,
    };
    return <RegistrationRole {...registrationRoleProps} />;
};

ConnectedRegistrationRole.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedRegistrationRole;
